import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import config from '../../../config';
import { formatPrice, formatCurrency } from '../../../helpers';
import fakeAuth from '../../../fakeAuth';
import eventBus from '../../../redux-sagas/events/bus';
import conversionRates from '../../../conversionRates';

// Solo los débitos reales se pueden mover de cuenta: nada de pagos, reembolsos ni IGTF.
export const isTransferable = (a) => parseFloat(a.Debit || 0) > 0
    && parseFloat(a.Credit || 0) === 0
    && !a.IsRefund
    && !a.IsTaxFree;

class Accounting extends React.Component {
    state = {
        sort: 'CreateDate',
        currency: localStorage.getItem('lb.currency') || 'USD',
        selected: [],
    }
    componentWillMount = () => {
        this.props.logic_actions?.fetch_conversion_rates();
        eventBus.on('lb.event.currency_change', this.onCurrencyChange);
    }
    componentWillReceiveProps = nextProps => {
        // Al salir del modo transferencia la selección se descarta
        if (this.props.transferring && !nextProps.transferring) this.setState({ selected: [] });
    }
    componentWillUnmount = () => {
        eventBus.off('lb.event.currency_change', this.onCurrencyChange);
    }

    onCurrencyChange = () => this.setState({ currency: localStorage.getItem('lb.currency') || 'USD' });

    onSort = (s) => {
        const { sort } = this.state;
        if (s === sort) this.setState({ up: !this.state.up });
        else this.setState({ up: false, sort: s });
    }

    // Selección
    transferables = () => _.filter(this.props.accounting || [], isTransferable);
    isSelected = (id) => this.state.selected.indexOf(id) !== -1;
    onToggle = (a) => {
        if (!isTransferable(a)) return;
        const { selected } = this.state, id = a.IdBookAccounting;
        this.setState({ selected: this.isSelected(id) ? _.without(selected, id) : [...selected, id] });
    }
    onToggleAll = () => {
        const all = this.transferables();
        this.setState({ selected: this.state.selected.length === all.length ? [] : _.map(all, a => a.IdBookAccounting) });
    }
    selectedCharges = () => _.filter(this.props.accounting || [], a => this.isSelected(a.IdBookAccounting));

    renderTH = () => {
        const { sort, selected } = this.state, { transferring } = this.props;
        let user = fakeAuth.getUser();
        let auditor = false;
        if ((user.Permissions & (config.permissions.SuperAdmin | config.permissions.Admin | config.permissions.Approve)) !== 0) auditor = true;

        const all = this.transferables();
        return <thead>
            <tr>
                {transferring && <th className="bg-gray-2 white text-center" style={{ width: 40 }}>
                    {all.length > 0 && <i title="Seleccionar todos los cargos"
                        className={`far fa-${selected.length === all.length ? 'check-square blue' : 'square gray'} pointer`}
                        onClick={this.onToggleAll} />}
                </th>}
                <th className="bg-gray-2 white">Fecha <i className={`icon-lb_sort ${sort === 'CreateDate' ? 'blue' : 'gray'}`}
                    onClick={() => this.onSort('CreateDate')} /></th>
                <th className="bg-gray-2 white">Concepto</th>
                <th className="bg-gray-2 white">Tipo</th>
                <th className="bg-gray-2 white">Crédito</th>
                <th className="bg-gray-2 white">Débito</th>
                <th className="bg-gray-2 white">Balance</th>
                <th className="bg-gray-2 white">Confirmación</th>
                {auditor && <th className="bg-gray-2 white text-center">Auditoria</th>}
            </tr>
        </thead>
    }

    // Barra de acción que aparece al seleccionar cargos
    renderActionBar = () => {
        const { selected, currency } = this.state;
        const charges = this.selectedCharges();
        const total = _.reduce(charges, (memo, c) => memo + parseFloat(c.Debit) * (currency === 'USD' ? 1 : (c.ConversionBS ?? 1)), 0);

        return <div className="d-flex bg-gray-3 black-input p-3 mt-3" style={{ borderRadius: 6, position: 'sticky', bottom: 20, zIndex: 50 }}>
            <div className="d-flex flex-column align-self-center">
                <span className="poppins white font-12">{selected.length} cargo{selected.length === 1 ? '' : 's'} seleccionado{selected.length === 1 ? '' : 's'}</span>
                <span className="poppins gray font-10">Total a transferir · <b className="blue">{formatCurrency(total, currency)}</b></span>
            </div>
            <button className="btn btn-link gray poppins font-10 ms-auto align-self-center" onClick={() => this.setState({ selected: [] })}>Limpiar selección</button>
            <button className="btn btn-blue white poppins font-12 ms-2 align-self-center"
                onClick={() => this.props.onTransfer && this.props.onTransfer(charges)}>
                <i className="fas fa-arrow-right me-2" />Transferir cargos
            </button>
        </div>
    }

    render() {
        const { accounting, transferring } = this.props, { sort, up, currency, selected } = this.state;
        const { payment_types } = config;
        const { property } = this.props;

        let user = fakeAuth.getUser();
        let auditor = false;
        if ((user.Permissions & (config.permissions.SuperAdmin | config.permissions.Admin | config.permissions.Approve)) !== 0) auditor = true;

        let SUB_TOTAL = _.chain(accounting).map(a => parseFloat(a.Debit) * (currency === 'USD' ? 1 : (a.ConversionBS ?? 1))).reduce((a, b) => a + b, 0).value(),
            TAXES = _.chain(accounting).reject(a => a.IsTaxFree).map(a => parseFloat(a.Debit) * (currency === 'USD' ? 1 : (a.ConversionBS ?? 1))).reduce((a, b) => a + b, 0).value() * (property ? (property.Tax || 0) : 0) / 100,
            BALANCE = (SUB_TOTAL + TAXES) - _.chain(accounting).map(a => parseFloat(a.Credit) * (currency === 'USD' ? 1 : (a.ConversionBS ?? 1))).reduce((a, b) => a + b, 0).value(),
            PROMO = 0;

        return <section>
            {accounting && <section>
                {transferring && <div className="d-flex bg-gray-3 black-input p-3 mb-3" style={{ borderRadius: 6 }}>
                    <i className="fas fa-info-circle blue align-self-center me-3" />
                    <span className="poppins white font-10 align-self-center">
                        Modo transferencia: marque los cargos que desea mover a la cuenta de otro huésped hospedado.
                        Los pagos, reembolsos e impuestos no son transferibles.
                    </span>
                </div>}
                <table className="w-100 table m-0 poppins bg-gray-2 white">
                    {this.renderTH()}
                    {accounting.length > 0 && <tbody>
                        {_.chain(accounting)
                            .sortBy(sort)
                            .tap(arr => {
                                if (up) arr.reverse();
                            })
                            .value().map((accounting) => {

                                accounting.PaymentType = parseFloat(accounting.Credit) ? (_.find(payment_types, pt => pt.id === accounting.IdPaymentType) || _.first(payment_types)).name : '-';

                                const transferable = isTransferable(accounting),
                                    checked = this.isSelected(accounting.IdBookAccounting),
                                    dimmed = transferring && !transferable;

                                return (<tr key={accounting.IdBookAccounting}
                                    className={transferring && transferable ? 'pointer' : ''}
                                    style={{ opacity: dimmed ? .35 : 1, backgroundColor: checked ? 'rgba(0,141,181,.15)' : 'transparent' }}
                                    onClick={() => transferring && this.onToggle(accounting)}>
                                    {transferring && <td className="bg-transparent white text-center">
                                        {transferable
                                            ? <i className={`far fa-${checked ? 'check-square blue' : 'square gray'} pointer`} />
                                            : <i title="Este movimiento no se puede transferir" className="fas fa-lock gray font-10" />}
                                    </td>}
                                    <td className="bg-transparent white">{moment(accounting.CreateDate).format('MMM Do YYYY @ HH:mmA')}</td>
                                    <td className="bg-transparent white">
                                        {accounting.Reason}
                                        {accounting.TransferFromIdBook && <i title={accounting.TransferNote} className="fas fa-exchange-alt blue font-10 ms-2" />}
                                        {accounting.TransferFromIdBook && <span className="poppins gray font-8 d-block">Transferido desde Reserva #{accounting.TransferFromPNR} · {accounting.TransferFromLabel}</span>}
                                    </td>
                                    <td className="bg-transparent white">{accounting.PaymentType}</td>
                                    <td className="bg-transparent white">{formatCurrency(parseFloat(accounting.Credit) * (currency === 'USD' ? 1 : (accounting.ConversionBS ?? 1)), currency)}</td>
                                    <td className="bg-transparent white">{formatCurrency(parseFloat(accounting.Debit) * (currency === 'USD' ? 1 : (accounting.ConversionBS ?? 1)), currency)}</td>
                                    <td className="bg-transparent white">{formatCurrency(parseFloat(accounting.Balance) * (currency === 'USD' ? 1 : (accounting.ConversionBS ?? 1)), currency)}</td>
                                    <td className="bg-transparent white">{accounting.Confirmation}</td>
                                    {auditor && <td className="bg-transparent white text-center">
                                        <i title={accounting.AuditComment || 'No ha sido auditado'} className={`fas fa-check ${accounting.AuditComment ? 'green' : 'gray'}`} onClick={(e) => { e.stopPropagation(); this.props.onAudit(accounting); }} />{((user.Permissions & (config.permissions.Approve)) !== 0) && <i className="fas fa-edit ms-2 pointer blue" onClick={(e) => { e.stopPropagation(); this.props.onAudit(accounting); }} />}</td>}
                                </tr>)
                            })}
                        <tr>
                            {transferring && <td className="bg-gray-2 white"></td>}
                            <td className="bg-gray-2 white"></td>
                            <td className="bg-gray-2 white">Impuestos ({property.Tax}%)</td>
                            <td className="bg-gray-2 white"></td>
                            <td className="bg-gray-2 white"></td>
                            <td className="bg-gray-2 white">{formatCurrency(TAXES, currency)}</td>
                            <td className="bg-gray-2 white">{formatCurrency(BALANCE, currency)}</td>
                            <td className="bg-gray-2 white"></td>
                            {auditor && <td className="bg-gray-2 white text-center"></td>}
                        </tr>
                    </tbody>}
                    {accounting.length === 0 && <tbody>
                        <tr>
                            <td colSpan={(auditor ? 8 : 7) + (transferring ? 1 : 0)} className="bg-gray-2 gray-light">
                                <div className="d-flex justify-content-center" style={{ height: 200 }}>
                                    <h3 className="align-self-center gray text-center poppins">No se han creado transacciones para esta reserva</h3>
                                </div>
                            </td>
                        </tr>
                    </tbody>}
                </table>
                {transferring && selected.length > 0 && this.renderActionBar()}
            </section>}
        </section>
    }
}

export default Accounting;
